import { useEffect, useState } from 'react';

/**
 * Hook para detectar se o usuário veio de uma campanha do Google Ads
 * Verifica os parâmetros UTM na URL
 */
export function useGoogleAdsDetection() {
  const [isFromGoogleAds, setIsFromGoogleAds] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source');
    const gclid = params.get('gclid'); // Google Click Identifier
    
    // Detecta se é tráfego do Google Ads
    const isGoogleAds = 
      utmSource === 'google_ads' || 
      utmSource === 'google' ||
      gclid !== null;
    
    setIsFromGoogleAds(isGoogleAds);

    // Salva no sessionStorage para manter durante a navegação
    if (isGoogleAds) {
      sessionStorage.setItem('from_google_ads', 'true');
    }
  }, []);

  return isFromGoogleAds || sessionStorage.getItem('from_google_ads') === 'true';
}
